import { render, staticRenderFns } from "./MenuManagement.vue?vue&type=template&id=66f9fd4e&scoped=true&"
import script from "./MenuManagement.vue?vue&type=script&lang=js&"
export * from "./MenuManagement.vue?vue&type=script&lang=js&"
import style0 from "./MenuManagement.vue?vue&type=style&index=0&id=66f9fd4e&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "66f9fd4e",
  null
  
)

export default component.exports